import React from 'react';
import { ChevronRight, Clock3 } from 'lucide-react';
import { stageName, workflowName } from './LaboratoryText';
import SampleStepNavigator from './SampleStepNavigator';
import { tx } from './i18n';
import './sample-lab-progress.css';

const when = value => new Date(value).toLocaleString(undefined, {
  day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
});

function WorkflowSteps({ workflow }) {
  const currentIndex = workflow.currentStep === null ? workflow.steps.length - 1
    : workflow.steps.findIndex(step => step.id === workflow.currentStep.id);
  const steps = workflow.steps.map(step => ({ ...step, label: stageName(step.code), completed: step.status === 'completed' }));
  return <section className="xo-sample-workflow">
    <header><strong title={workflowName(workflow.workflow.code)}>{workflow.workflow.code}<small> · {workflow.printedTubeCode ?? workflow.tubeCode}</small></strong>
      <small>{tx('ui.lab.work.progress', { done: workflow.completedSteps, total: workflow.totalSteps })}</small>
    </header>
    {steps.length === 0 ? <p>{tx('ui.samples.lab_progress_no_steps')}</p> : <SampleStepNavigator
      steps={steps} currentIndex={currentIndex} label={tx('ui.samples.workflow_step_navigation', { workflow: workflow.workflow.code })}>
      {(step, isCurrent) => <div className="xo-sample-workflow-step">
        <div className="xo-sample-workflow-copy">
          <span>{isCurrent && !['completed', 'stopped'].includes(workflow.status) ? tx('ui.samples.current_step_be1ac4e3') : tx(`ui.lab.work.status.${step.status}`)}</span>
          <strong>{step.label}</strong>
          {isCurrent && ['awaiting_approval', 'awaiting_customer', 'needs_changes', 'repeat', 'stopped'].includes(step.status)
            && <span className="xo-sample-workflow-hold">{tx(`ui.lab.work.status.${step.status}`)}</span>}
          <div className="xo-sample-workflow-times"><Clock3 aria-hidden="true" />
            {step.performedAt === null ? <span>{tx('ui.samples.step_not_started')}</span> : <div>
              {step.completedAt === null || step.performedAt !== step.completedAt
                ? <time dateTime={new Date(step.performedAt).toISOString()}>{tx('ui.samples.step_submitted_at', { at: when(step.performedAt) })}</time> : null}
              {step.reviewedAt !== null && step.completedAt === null
                && <time dateTime={new Date(step.reviewedAt).toISOString()}>{tx('ui.samples.step_reviewed_at', { at: when(step.reviewedAt) })}</time>}
              {step.completedAt !== null
                && <time dateTime={new Date(step.completedAt).toISOString()}>{tx('ui.samples.step_completed_at', { at: when(step.completedAt) })}</time>}
            </div>}
          </div>
        </div>
      </div>}
    </SampleStepNavigator>}
  </section>;
}

export default function SampleLabProgress({ workflows }) {
  return <details className="xo-sample-lab-progress">
    <summary><ChevronRight aria-hidden="true" /><span>{tx('ui.samples.lab_progress')}</span><small>{workflows.length}</small></summary>
    {workflows.length === 0 ? <p>{tx('ui.samples.lab_progress_empty')}</p>
      : <div className="xo-sample-workflows">{workflows.map(workflow => <WorkflowSteps key={workflow.uuid} workflow={workflow} />)}</div>}
  </details>;
}
